import { useLanguage } from '../LanguageContext';
import React, { useState, useEffect } from 'react';
import axiosInstance from '../axiosInstance';

const noop = () => {};
const Login = ({ setRole = noop, setShowNavbar = noop }) => {
  const { t } = useLanguage();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(true);

  // ✅ Check if a valid token exists and redirect
  useEffect(() => {
    setShowNavbar(false); // Hide navbar on login page

    const checkToken = async () => {
      try {
        const response = await axiosInstance.get("/api/check-auth", { withCredentials: true });

        if (response.data && response.data.success) {
          console.log("✅ User already authenticated. Redirecting to Player List...");

          setRole(response.data.role || "guest");

          // ✅ Ensure navigation happens AFTER state update
          setTimeout(() => {
            window.location.href = "/player-list"; // ✅ More reliable than navigate()
          }, 100);
        } else {
          console.warn("⚠️ User is not authenticated:", response.data);
        }
      } catch (error) {
        console.error("❌ Error fetching user role:", error);

        // ✅ Catch and log response errors
        if (error.response) {
          console.error("🔍 Response Error:", error.response.status, error.response.data);
        } else if (error.request) {
          console.error("🛑 No response received:", error.request);
        } else {
          console.error("❌ Request error:", error.message);
        }
      } finally {
        setIsLoading(false);
      }
    };

    checkToken();
  }, [setRole, setShowNavbar]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(""); // Reset error on new attempt

    try {
      // ✅ Login Request (JWT stored in HTTP-only cookie)
      const loginResponse = await axiosInstance.post(
        "/api/login", // ✅ corrected path
        { username, password },
        { withCredentials: true }
      );

      console.log('✅ Login successful:', loginResponse.data);

      if (loginResponse.data.success) {
        console.log("🔄 Fetching User Role after Login...");

            const userRole = loginResponse.data.role || "guest"; // get the role from the login response
            setRole(userRole);
            setShowNavbar(true);

            setTimeout(() => {
              window.location.href = "/player-list";
            }, 100);
      } else {
        setError(t("❌ Authentication failed. Please try again."));
      }
    } catch (err) {
      console.error('❌ Login error:', err.response?.data || err.message);
      setError(
        err.response?.data?.error ||
        t("⚠️ Server error. Try again later.")
      );
    }
  };

  // ✅ Display loading message
  if (isLoading) {
    return <div>{t("Loading...")}</div>;
  }
  try {
    return (
      <div className="login-container">
        <div className="login-card">
          <h1 className="login-title">{t("Admin Login")}</h1>
          {error && <p className="error-message">{t(error)}</p>}
          <form onSubmit={handleSubmit} className="login-form">
            <div className="form-group">
              <label htmlFor="username">{t("Username:")}</label>
              <input
                type="text"
                id="username"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                placeholder={t("Enter your username")}
                className="login-input"
                required
              />
            </div>
            <div className="form-group">
              <label htmlFor="password">{t("Password:")}</label>
              <input
                type="password"
                id="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder={t("Enter your password")}
                className="login-input"
                required
              />
            </div>
            <button type="submit" className="login-button">{t("Login")}</button>
          </form>
        </div>
      </div>
    );
  } catch (error) {
    console.error("❌ React Render Error:", error);
    return <h1>{t("⚠️ Error Rendering Page")}</h1>;
  }
};

export default Login;
